import { RouteProps } from "react-router";
import React from "react";
import { Route } from "react-router-dom";

export function PrivateRoute1({ children, ...rest }: RouteProps): JSX.Element {
  return <Route {...rest} render={() => children} />;
}
